import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3Div from "../../../../core/et3-div";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { TSubscriptionType } from "../../../../Types";
import TagBadge from "./TagBadge";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import { faCalendarDay, faHourglass } from "@fortawesome/free-solid-svg-icons";
import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import getCorePopUpStore from "../../../../stores/core/core-popup-store";
import getGiveSubscriptionsStore from "../../../../stores/scsr-store/give-subscriptions";

const UserSetSubscriptions = withLiteObserverAndTheme<{
  subscriptionType: TSubscriptionType;
}>((props) => {
  const { subscriptionType, theme } = props;
  const { colors, unitX } = theme;

  const { placeholders, buttonText } =
    getGiveSubscriptionsStore().getPlaceholdersAndButtonText(subscriptionType);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={370}
      height={270}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.white}
      style={{
        borderRadius: 16 * unitX,
        overflow: "hidden",
        border: `1px solid ${colors.all.paleBluishGray}`,
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)"
      }}
      onClick={() => {}}
    >
      <TagBadge tagType={subscriptionType} />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={370}
        height={270}
        fDirection="column"
        alignItems="center"
        justifyContent="space-between"
        color={colors.all.white}
        style={{
          boxSizing: "border-box",
          paddingLeft: 20 * unitX,
          paddingRight: 20 * unitX
        }}
        onClick={() => {}}
      >
        <Et3Margin top={14} bottom={0} left={0} right={0} />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faCalendarDay}
          label={""}
          placeHolder={i18n.get(placeholders.DAYS)}
          value={getGiveSubscriptionsStore().getSubscriptionInputTime(
            "DAYS",
            subscriptionType
          )}
          onChoose={(value: number) => {
            getGiveSubscriptionsStore().setSubscriptionTime(
              value,
              "DAYS",
              subscriptionType
            );
          }}
          onBlur={() => {
            getGiveSubscriptionsStore().validateSubscriptionTime(
              "DAYS",
              subscriptionType
            );
          }}
          style={{}}
          onEnter={() => {}}
        />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faHourglass}
          label={""}
          placeHolder={i18n.get(placeholders.HOURS)}
          value={getGiveSubscriptionsStore().getSubscriptionInputTime(
            "HOURS",
            subscriptionType
          )}
          onChoose={(value: number) => {
            getGiveSubscriptionsStore().setSubscriptionTime(
              value,
              "HOURS",
              subscriptionType
            );
          }}
          onBlur={() => {
            getGiveSubscriptionsStore().validateSubscriptionTime(
              "HOURS",
              subscriptionType
            );
          }}
          style={{}}
          onEnter={() => {}}
        />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faHourglass}
          label={""}
          placeHolder={i18n.get(placeholders.MINUTES)}
          value={getGiveSubscriptionsStore().getSubscriptionInputTime(
            "MINUTES",
            subscriptionType
          )}
          onChoose={(value: number) => {
            getGiveSubscriptionsStore().setSubscriptionTime(
              value,
              "MINUTES",
              subscriptionType
            );
          }}
          onBlur={() => {
            getGiveSubscriptionsStore().validateSubscriptionTime(
              "MINUTES",
              subscriptionType
            );
          }}
          style={{}}
          onEnter={() => {}}
        />
        <Et3Button
          isEnabled={getGiveSubscriptionsStore().isSubscriptionButtonEnabled(
            subscriptionType
          )}
          onClick={async () => {
            getCorePopUpStore().openConfirmationPopUps(
              "GIVE_SUBSCRIPTION_CONFIRMATION_POPUP",
              subscriptionType
            );
          }}
          type="GET"
          size="MEDIUM"
          text={buttonText}
        />
        <Et3Margin top={14} bottom={0} left={0} right={0} />
      </ET3Div>
    </ET3Div>
  );
});

export default UserSetSubscriptions;
